import config from "./config";

type AnimationProps = {
  thumbFormat?: string | null;
  altThumbnail?: string | null;
  url: string;
  version?: number | null;
}

export default function getThumbnailPath({ animation }: { animation: AnimationProps }) {
  if (animation.altThumbnail) {
    return `${config.s3Path}${animation.altThumbnail}`;
  }
  const thumbFormats = animation.thumbFormat?.split(",") ?? [];
  const version = animation.version ?? 0;

  if (thumbFormats.includes("WEBP")) return `${config.s3Path}/${animation.url}/thumb.webp?v=${version}`;
  if (thumbFormats.includes("PNG")) return `${config.s3Path}/${animation.url}/thumb.png?v=${version}`;

  // Default to the first frame if no thumbnail formats are available
  return `${config.s3Path}/${animation.url}/0.png?v=${version}`;
};